import React from 'react';
import LinkBase from './LinkBase';

const Link = (props) => <LinkBase {...props} />;

export default Link;
